import React, { useEffect, useState } from "react";
import "./styles.scss";
import CheckboxOn from "../../../../assets/images/CheckboxOn.svg";
import CheckboxOff from "../../../../assets/images/CheckboxOff.svg";
import BrandImage from "../../../../assets/images/brandImage.svg";
import Imagebrand from "../../../../assets/images/imag.svg";
import Afribrand from "../../../../assets/images/afriglobal.svg";
import Lancetbrand from "../../../../assets/images/lancet.svg";
import Closeicon from "../../../../assets/images/SheetClose.svg";
import _ from "lodash";
import Dnabrand from "../../../../assets/images/dna.svg";
import Clinixbrand from "../../../../assets/images/clinix.svg";
import Accunalysisbrand from "../../../../assets/images/accunalysis.svg";
import Synlabbrand from "../../../../assets/images/synlab.svg";
import Echobrand from "../../../../assets/images/echo.svg";
import Mecurebrand from "../../../../assets/images/mecure.svg";
import Docbrand from "../../../../assets/images/docbrand.svg";
import Unionbrand from "../../../../assets/images/union.svg";
import { api } from "../../../../utils/constants";
import axios from "../../../../redux/axios";
import { Grid, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import { useSelector } from "react-redux";

const apiData = {
  data: [
    {
      test_type: "pathology",
      testname_uuid: "LP-B47D8FD1",
      areaRef: "AR-35271B1F",
    },
    {
      test_type: "radiology",
      testname_uuid: "LR-74C1ABD3",
      areaRef: "AR-35271B1F",
    },
    {
      test_type: "pathology",
      testname_uuid: "LP-B708639F",
      areaRef: "AR-35271B1F",
    },
  ],
  homeservice: "yes",
};
function Popup(props) {

  console.log("Popup props", props);
  const [selectedPartner, setSelectedPartner] = useState([]);
  const [partnerlist, setPartnerlist] = useState([]);

  const theme = useTheme();
  const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileView, setMobileView] = useState(false);
  const [includedPartner, setIncludedPartner] = useState([]);

  const partner = useSelector((state) => state.auth.partners);

  const handleRadio = (val) => {
    if (selectedPartner.includes(val.diagnosticspartner)) {
      const filteredPeople = selectedPartner.filter(
        (item) => item !== val.diagnosticspartner
      );
      setSelectedPartner(filteredPeople);
    } else {
      setSelectedPartner([...selectedPartner, val.diagnosticspartner]);
    }
  };

  useEffect(() => {
    if (props.resp && props.resp.data) {
      let data = props.resp.data.map((item) => {
        return item.diagnosticspartner;
      });
      setIncludedPartner(data);
    }

  }, [props]);

  useEffect(() => {
    let payLoad = {
      data: _.uniqBy(apiData.data, "testname_uuid"),
      homeservice: "yes",
    };
    var config = {
      method: "post",
      url: api.compareprice_get,
      headers: {
        "Content-Type": "application/json",
      },
      data: payLoad,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status == "Success") {
          setPartnerlist(response.data.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);
  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 767
        ? setMobileView(true)
        : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);
  return (
    <>
      <div className="parentContainer-diagnostic-partner">
        <div className="top-font">
          {(props.view && (
            <img alt="icon" src={Closeicon} onClick={() => props.onClose(false)} />
          )) ||
            ""}
          Select Diagnostic Partner
        </div>
        {mobileView &&
          <div
            style={{ cursor: "pointer" }}
            className="labmodal_close"

            onClick={() => {
              // props.view(false);
              // props.close(false)
              props.onClose(false)
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 15L15 1M1 1L15 15L1 1Z"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        }
        {!mobileView &&
          <div
            style={{ cursor: "pointer" }}
            className="labmodal_close"

            onClick={() => {
              // props.view(false);
              // props.close(false)
              props.close(false)
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 15L15 1M1 1L15 15L1 1Z"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        }
        <div className="top-divider"></div>
        <div className="partner-container-out">
          {props.resp.data &&
            props.resp.data.length > 0 &&
            props.resp.data.map((val, ind) => {
              return (
                <div
                  className={
                    selectedPartner.includes(val.diagnosticspartner)
                      ? "outer-border"
                      : "outer-border-none outer-border"
                  }
                >
                  <div className="partner-cont">
                    {/* <div
                      className="left-cont"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRadio(val);
                      }}
                    >
                      {/* {selectedPartner.indexOf(val.diagnosticspartner) > -1 ? (
                        <img crossOrigin="anonymous" src={CheckboxOn} />
                      ) : (
                        <img crossOrigin="anonymous" src={CheckboxOff} />
                      )} 
                    </div> */}
                    <div className="left-cont" style={{ width: "10%" }}>
                      {" "}
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          e.stopPropagation();
                          handleRadio(val);
                        }}
                      />
                    </div>

                    <div className="right-cont-out">
                      {val.diagnosticspartner === "SYNLAB" ? (
                        <img src={Synlabbrand} alt="Synlabbrand" />
                      ) : val.diagnosticspartner === "ECHOLAB" ? (
                        <img src={Echobrand} alt="Echobrand" />
                      ) : val.diagnosticspartner === "UNION DIAGNOSTICS" ? (
                        <img src={Unionbrand} alt="Unionbrand" />
                      ) : val.diagnosticspartner === "IMAGE DIAGNOSTICS" ? (
                        <img src={Imagebrand} alt="Imagebrand" />
                      ) : val.diagnosticspartner === "DNA LABS" ? (
                        <img src={Dnabrand} alt="Dnabrand" />
                      ) : val.diagnosticspartner === "CLINIX" ? (
                        <img src={Clinixbrand} alt="Clinixbrand" />
                      ) : val.diagnosticspartner === "CLINA LANCET" ? (
                        <img src={Lancetbrand} alt="Lancetbrand" />
                      ) : val.diagnosticspartner === "AFRIGLOBAL" ? (
                        <img src={Afribrand} alt="Afribrand" />
                      ) : val.diagnosticspartner === "DOCTALL" ? (
                        <img src={Docbrand} alt="Docbrand" />
                      ) : (
                        <div className="top-font">{val.diagnosticspartner}</div>
                      )}
                      {/* <div className="brand-text">Union Diagnostic&<span>Clinical Services</span></div> */}
                      {/* <div className="brand-text">{val.diagnosticspartner}</div> */}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        <div
          className="filter-button"
          onClick={() => props.brandfilter(selectedPartner)}
        >
          <span>Apply Filter</span>
        </div>
        <div className="right-cont-out">
          <div style={{ margin: "2%" }}>
            <u>
              <b>Other Available Diagnostic Partners</b>
            </u>
          </div>
          <Grid
            item
            container
            style={{ padding: "30px" ,width:"150px"}}
            justifyContent={matchesMD ? "space-between" : undefined}
          >
            {partner &&
              partner.map((item) => (
                <>
                  {includedPartner && includedPartner.includes(item.name) ? (
                    <></>
                  ) : (
                    <Grid
                      item
                      container
                      justifyContent={matchesMD ? undefined : "center"}
                      alignItems={matchesMD ? undefined : "center"}
                      lg={2}
                      md={4}
                      xs={12}
                      style={{
                        width: "250px",
                        marginRight: "30px",
                        marginBottom: "30px",
                      }}
                    >
                      <img style={{ margin: "2%",width:"150px" }} src={item.logo} alt="" />
                    </Grid>
                  )}
                </>
              ))}
          </Grid>
        </div>
       
      </div>
    </>
  );
}

export default Popup;
